export const TextEffectsGlassViewerType = 'wixui.TextEffectsGlass' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsGlass-container',
    text: 'TextEffectsGlass-text',
  },
} as const;

export const blurConfig = {
  start: 2,
  end: 10,
  step: 1,
};
